import {useEffect, useMemo} from 'react';
import {transformExtent} from 'ol/proj';

import {EPSG4326} from 'topmeteo/flight-planning/utils/projection';

import {useImageLayer, useImageStaticSource} from '../OpenLayers/hooks';

const WeatherImage = ({url, opacity = 1, projection, extent, visible = true, zIndex = 0}) => {
    const imageExtent = useMemo(() => transformExtent(extent, EPSG4326, projection), [extent, projection]);
    const source = useImageStaticSource({url, projection, imageExtent}, [url, projection, imageExtent]);
    const layer = useImageLayer({opacity, source, visible, zIndex}, []);

    useEffect(() => layer.setSource(source), [source, layer]);
    useEffect(() => layer.setOpacity(opacity), [opacity, layer]);
    useEffect(() => layer.setVisible(visible), [visible, layer]);

    return null;
};

export default WeatherImage;
